export default __webpack_public_path__ + "static/media/icon-treasure.382ce1be.svg";